module.exports = __webpack_public_path__ + "img/programme_icon_pintuanyingxiao@3x.478a977b.png";